import ItmChildrens from "./itm-configuration/ItmChildrens";

const RelationTab = () =>
  import(
    /* webpackChunkName: "RelationTab" */ `@/components/rapsotec/projects/project/details/RelationTab.vue`
  );
const AffaireTab = () =>
  import(
    /* webpackChunkName: "AffaireTab" */ `@/components/rapsotec/projects/project/details/AffaireTab.vue`
  );
const MissionTab = () =>
  import(
    /* webpackChunkName: "MissionTab" */ `@/components/rapsotec/projects/project/details/MissionTab.vue`
  );
const CanvasDestinationTab = () =>
  import(
    /* webpackChunkName: "CanvasDestinationTab" */ `@/components/rapsotec/projects/project/details/CanvasDestinationTab.vue`
  );
const RVRATTab = () =>
  import(
    /* webpackChunkName: "RVRATTab" */ `@/components/rapsotec/projects/project/details/RVRATTab.vue`
  );
const CanvasDescriptionTab = () =>
  import(
    /* webpackChunkName: "CanvasDescriptionTab" */ `@/components/rapsotec/projects/project/details/CanvasDescriptionTab.vue`
  );

/** CHILDREN **/
const CanvasFirstStep = () =>
  import(
    /* webpackChunkName: "CanvasFirstStep" */ `@/components/rapsotec/projects/project/details/destination/CanvasFirstStep.vue`
  );
const CanvasSecondStep = () =>
  import(
    /* webpackChunkName: "CanvasSecondStep" */ `@/components/rapsotec/projects/project/details/destination/CanvasSecondStep.vue`
  );
const IdentityRVRAT = () =>
  import(
    /* webpackChunkName: "IdentityRVRAT" */ `@/components/rapsotec/projects/project/details/rvrat/IdentityRVRAT.vue`
  );
const RVRATTables = () =>
  import(
    /* webpackChunkName: "InspectionOverviewTables" */ `@/components/rapsotec/projects/project/details/partials/InspectionOverviewTables.vue`
  );
const AnswerForm = () =>
  import(
    /* webpackChunkName: "AnswerForm" */ `@/components/rapsotec/projects/project/details/description/AnswerForm.vue`
  );
const RD0Configuration = () =>
  import(
    /* webpackChunkName: "RD0Configuration" */ `@/components/rapsotec/projects/project/details/RD0Configuration.vue`
  );
const ITMTab = () =>
  import(
    /* webpackChunkName: "ITMTab" */ `@/components/rapsotec/projects/project/details/ITMTab.vue`
  );
export default [
  {
    path: "",
    name: "projectDetailCase",
    component: AffaireTab,
  },
  {
    path: "relation",
    name: "projectDetailRelation",
    component: RelationTab,
  },
  {
    path: "mission",
    name: "projectDetailMission",
    component: MissionTab,
  },
  {
    path: "destinations",
    component: CanvasDestinationTab,
    children: [
      {
        path: "",
        name: "canvasDestination",
        component: CanvasFirstStep,
      },
      {
        path: "2",
        name: "canvasDestinationSecond",
        component: CanvasSecondStep,
      },
    ],
  },
  {
    path: "rvrat",
    component: RVRATTab,
    children: [
      {
        path: "",
        name: "rvratTab",
        component: IdentityRVRAT,
      },
      {
        path: "tables",
        name: "rvratTabTables",
        component: RVRATTables,
      },
    ],
  },
  {
    path: "description",
    component: CanvasDescriptionTab,
    children: [
      {
        path: ":currentStep?",
        name: "answerForm",
        component: AnswerForm,
      },
    ],
  },
  {
    path: "rd0Configuration",
    name: "rd0Configuration",
    component: RD0Configuration,
  },
  {
    path: "itm",
    name: "itm",
    component: ITMTab,
    children: ItmChildrens,
  },
];
